import React from 'react';

export const Image =(props:any)=>{
    const {src}=props;
    console.log(src);
    return(
        <div className="imageParentDiv">
             <img crossOrigin="anonymous" src={src} alt="" className={props.className} />
        </div>
    )
}